<template>
  <div class="custom-listing">
    <BlueprintListing @loading="setLoading" />
  </div>
  <div class="custom-loading-background" v-if="loading">
    <div class="custom-loading">
      <span class="custom-spinner">
        <i class="fas fa-spinner fa-spin"></i>
        <span>Loading...</span>
      </span>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import BlueprintListing from '@/components/blueprint/BlueprintListing.vue'
export default {
  name: 'BlueprintView',
  components: {
    BlueprintListing
  },
  data() {
    return {
      loading: false
    }
  },
  async mounted() {
    this.resetPreferences()
    await this.getPreferences({
      firm: this.profile.firm,
      category: 'General',
      name: 'isInsurer'
    })
    await this.getPreferences({
      firm: this.profile.firm,
      category: 'General',
      name: 'isPartOfProviderPrograms'
    })
    await this.getPreferences({
      firm: this.profile.firm,
      category: 'General',
      name: 'optOutOthersBPCP'
    })
    await this.getPreferences({
      firm: this.profile.firm,
      category: 'General',
      name: 'isDontAllowBPCPShareChecks'
    })
  },
  computed: {
    ...mapState(authStore, ['profile']),
  },
  methods: {
    ...mapActions(locationStore, ['resetPreferences', 'getPreferences']),
    setLoading(value) {
      console.log('Loading state:', value)
      this.loading = value
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-listing {
  position: relative;
}

.custom-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
}

.custom-loading-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.custom-spinner {
  font-size: 24px;
  color: #007bff;
}
</style>
